import React, { useCallback, useRef, useState } from 'react';
// import { useParams } from 'react-router-dom';
import Layout from '../../../../layout/Layout';
import { Box } from '../../../../components/atoms/AppBox';
import AppButton from '../../../../components/atoms/AppButton/AppButton';
import { useCompanyDetail } from '../../../presentation/hooks/useCompaniesDetail';
// import Breadcrumb from '../../../../components/atoms/Breadcrumb/Breadcrumb';
import CompanyInfoSection from '../../components/organims/CompanyInfoSection';
import { WarehousesTable } from '../../components/organims/WarehouseTable';
import { companyWarehouse } from '../../../domain/companyWarehouse';
import AppModalGeneral from '../../../../components/atoms/AppModalGeneral/AppModalGeneral';
import AddWarehouseForm from '../../components/molecules/AddWarehouseForm';
import ConfirmDeleteModal from '../../components/molecules/ConfirmModal';
import { useAddWarehouse } from '../../hooks/useAddWarehouse';
import { useDeleteWarehouse } from '../../hooks/useDeleteWarehouse';
import { Snackbar } from '../../../../components/atoms/Snackbar/Snackbar';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection';

export default function CompanyDetailPage() {
    // const { id } = useParams<{ id: string }>()
    const userState = useSelector((state: RootState) => state.user)
    const storedUser = userState?.user
    const companyId = String(storedUser?.company.id)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [warehouseToDelete, setWarehouseToDelete] =
        useState<companyWarehouse | null>(null)
    const snackbarRef = useRef<{ showModal: (b: boolean) => void }>(null)
    const [snackbarMessage, setSnackbarMessage] = useState<{
        title: string
        description: string
        state: 'success' | 'error'
    }>({
        title: '',
        description: '',
        state: 'success',
    })

    const {
        company,
        loading,
        error,
        mutate: refreshCompanyData,
    } = useCompanyDetail(companyId ?? '')
    const {
        addWarehouse,
        error: addWarehouseError,
        reset: resetAddWarehouse,
    } = useAddWarehouse()

    const {
        deleteWarehouse,

        reset: resetDeleteWarehouse,
    } = useDeleteWarehouse()

    const handleAddWarehouse = async (data: {
        warehouse: string
        ciudad: string
        direccion: string
    }) => {
        if (companyId == null || companyId === '') return
        const wareHouseData = {
            id: companyId,
            name: data.warehouse,
            city: data.ciudad,
            address: data.direccion,
            company_id: Number(companyId),
        }

        const responseWarehouse = await addWarehouse(wareHouseData)

        if (responseWarehouse) {
            await refreshCompanyData()
            setSnackbarMessage({
                title: '¡Éxito!',
                description: 'Warehouse creado exitosamente',
                state: 'success',
            })
            setTimeout(() => {
                snackbarRef.current?.showModal(true)
            }, 0)
            setIsModalOpen(false)
        } else {
            const errorMessage =
                addWarehouseError?.message ?? 'Error al crear el warehouse'
            setSnackbarMessage({
                title: 'Error',
                description: errorMessage,
                state: 'error',
            })
            setTimeout(() => {
                snackbarRef.current?.showModal(true)
            }, 0)
        }
    }
    const handleDeleteRequest = (warehouse: companyWarehouse) => {
        setWarehouseToDelete(warehouse)
    }

    const handleConfirmDelete = useCallback(async () => {
        if (!warehouseToDelete) return

        const success = await deleteWarehouse(warehouseToDelete.id.toString())

        if (success) {
            resetDeleteWarehouse()
            await refreshCompanyData()
            setSnackbarMessage({
                title: '¡Éxito!',
                description: 'Warehouse eliminado exitosamente',
                state: 'success',
            })
            setTimeout(() => {
                snackbarRef.current?.showModal(true)
            }, 0)
        } else {
            setSnackbarMessage({
                title: 'Error',
                description: 'No se pudo eliminar el warehouse',
                state: 'error',
            })
            setTimeout(() => {
                snackbarRef.current?.showModal(true)
            }, 0)
        }
        setWarehouseToDelete(null)
    }, [warehouseToDelete, deleteWarehouse])

    const handleCancelDelete = () => {
        setWarehouseToDelete(null)
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
        resetAddWarehouse()
    }

    const formatDate = (date: Date | string) => {
        const d = new Date(date)
        return {
            date: d.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }),
            time:
                d.toLocaleTimeString('es-ES', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                }) + ' hs',
        }
    }

    // const breadcrumbItems = [
    //     { label: 'Empresas', path: '/companies' },
    //     { label: company ? company.name : 'Empresa', path: `/companies/${id}` },
    // ]

    if (loading === true) {
        return (
            <Layout>
                <div className="flex items-center justify-center h-screen">
                    <p className="text-lg text-gray-600">Cargando empresa...</p>
                </div>
            </Layout>
        )
    }

    if (error != null && error !== '') {
        return (
            <Layout>
                <div className="flex items-center justify-center h-screen">
                    <p className="text-lg text-red-600">Error: {error}</p>
                </div>
            </Layout>
        )
    }

    return (
        <Layout>
          <HeaderPageSection title="Warehouses" showGoBack={false}>
              <AppButton
                title="Agregar warehouse"
                style={{
                  backgroundColor: '#568C13',
                }}
                onClick={() => setIsModalOpen(true)}
              />
          </HeaderPageSection>
            {/*<Breadcrumb*/}
            {/*    items={breadcrumbItems}*/}
            {/*    title="Warehouses"*/}
            {/*    separator={<span className="text-gray-400">/</span>}*/}
            {/*    showGoBack={true}*/}
            {/*    className="mt-6 mb-6"*/}
            {/*>*/}
            {/*    <div>*/}
            {/*        <AppButton*/}
            {/*            title="Agregar warehouse"*/}
            {/*            style={{*/}
            {/*                backgroundColor: '#568C13',*/}
            {/*                marginBottom: '1rem',*/}
            {/*            }}*/}
            {/*            onClick={() => setIsModalOpen(true)}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</Breadcrumb>*/}
            {company != null && (
                <CompanyInfoSection company={company} formatDate={formatDate} />
            )}
            {company != null && (
                <Box>
                    <WarehousesTable
                        warehouses={
                            Array.isArray(company.warehouses)
                                ? company.warehouses
                                : []
                        }
                        onDeleteRequest={handleDeleteRequest}
                    />
                </Box>
            )}

            <AppModalGeneral isOpen={isModalOpen}>
                <AddWarehouseForm
                    onClose={handleCloseModal}
                    onSubmit={handleAddWarehouse}
                />
            </AppModalGeneral>

            <ConfirmDeleteModal
                isOpen={warehouseToDelete != null}
                title="Desvincular Warehouse"
                itemName={warehouseToDelete?.name ?? ''}
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />

            <Snackbar
                ref={snackbarRef}
                title={snackbarMessage.title}
                description={snackbarMessage.description}
                state={snackbarMessage.state}
                time={3000}
            />
        </Layout>
    )
}
